import Collection from '../collection';
import Role from '../model/role';





export default Collection.extend( {
    endpoint: 'users/roles?apiVersion=2.0',
    responseAt: 'items',
    model: Role,
} );


// WEBPACK FOOTER //
// ./src/js/collection/roles.js